// helper comuni della sezione Volantini

export const LINGUE = { it: 'Italiano', en: 'Inglese', fr: 'Francese', de: 'Tedesco', es: 'Spagnolo' };

export function bandiera(lang) {
	try {
		return require(`@/assets/images/flag/${String(lang).toUpperCase()}.svg`);
	} catch (e) {
		return require('@/assets/images/flag/map.svg');
	}
}

/** Copia negli appunti; ripiego su execCommand dove la Clipboard API non c'e' (http). */
export function copiaTesto(testo) {
	if (navigator.clipboard && window.isSecureContext) {
		return navigator.clipboard
			.writeText(testo)
			.then(() => true)
			.catch(() => false);
	}
	const ta = document.createElement('textarea');
	ta.value = testo;
	ta.style.position = 'fixed';
	ta.style.opacity = '0';
	document.body.appendChild(ta);
	ta.select();
	let ok = false;
	try {
		ok = document.execCommand('copy');
	} catch (e) {
		ok = false;
	}
	document.body.removeChild(ta);
	return Promise.resolve(ok);
}

/** Form vuoto di un nuovo volantino. */
export function nuovoVolantino(lingue, theme) {
	return {
		name: '',
		occasion: 'neutro',
		langs: lingue.slice(0, 1),
		trans: lingue.slice(0, 1).map(lang => ({ lang, title: '', subtitle: '' })),
		valid_from: '',
		valid_to: '',
		filters: { brands: [], categories: [], offers: [], items: [], min_price: 0, sort: 'discount', only_available: false },
		theme: { ...theme },
		layout: { per_page: 6, show_logo: true },
		active: true,
	};
}
